<div class="input-container">
  <label>{{ placeholder || 'Select Time' | translate }}</label>
  <div class="input-group">
    <div ngbDropdown class="d-inline-block"
         container="body"
         (openChange)="onOpen($event)"
         #dropdown="ngbDropdown">
      <div class="input-group">
        <input
          type="text"
          class="form-control primary-100"
          [placeholder]="placeholder || 'Select Time' | translate"
          [ngModel]="{optionRef: selectedTime} | bringozTime: 'optionRef'"
          [disabled]="isDisabled"
          [required]="isRequired"
          readonly
          (click)="!isDisabled && dropdown.open()"
          ngbDropdownToggle
        />
        <div class="input-group-append">
          <bringoz-button type="tertiary"
                          (onClick)="!isDisabled && dropdown.open()"
                          [isDisabled]="isDisabled">
            <bringoz-icon iconName="chevron-down"></bringoz-icon>
          </bringoz-button>
        </div>
      </div>

      <div ngbDropdownMenu class="dropdown-menu padding-0">
        <div class="dropdown-header">
          <input
            type="text"
            class="form-control search-input"
            [(ngModel)]="searchTerm"
            (ngModelChange)="filterOptions()"
            placeholder="{{ 'Search time' | translate }}"
            (click)="$event.stopPropagation()"
            (keydown)="$event.stopPropagation()"
          />
        </div>

        <div class="dropdown-scrollable-content">
          <button
            *ngFor="let option of filteredOptions"
            class="dropdown-item primary-100"
            type="button"
            [class.active]="option === selectedTime"
            (click)="onTimeSelect(option)">
            <span class="br-body-2">{{ {optionRef: option} | bringozTime: 'optionRef' }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="isRequired" class="invalid-feedback">
    {{ 'This field is required' | translate }}
  </div>
</div>
